import { FC, useMemo } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as styles from 'styles/molecules/forms/Form.css'
import schema from 'schemas/deviceVerificationFormSchema'
import { asyncValidator } from 'helpers/schemaHelpers'
import { FORM_DEVICE_VERIFICATION } from 'constants/forms'
import Button from 'components/features/pfm/Button/Button'
import { ReduxFormProps } from 'interfaces/component'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import CheckboxWrapped from 'components/atoms/inputs/CheckboxWrapped'
import { getSaveButtonFormProps, onFormSubmit, parseValueToBoolean, shouldAsyncValidate } from 'helpers/formHelpers'
import { FIELD_EMAIL_PROPS } from 'constants/fields'
import { VerificationCodeHintBox } from 'components/features/pfm/VerificationCodeHintBox/VerificationCodeHintBox'

type DeviceVerificationFormProps = ReduxFormProps

const DeviceVerificationFormComponent: FC<DeviceVerificationFormProps> = (props) => {
  const { handleSubmit } = props

  const emailFieldProps = useMemo(() => ({
    ...FIELD_EMAIL_PROPS,
    disabled: true,
    autoComplete: 'off',
  }), [])

  const passwordFieldProps = useMemo(() => ({
    label: 'Password',
    type: 'password',
    disabled: true,
    autoComplete: 'new-password',
  }), [])

  const codeFieldProps = useMemo(() => ({
    autoFocus: true,
    label: 'Code',
    type: 'text',
  }), [])

  const rememberFieldProps = useMemo(() => ({
    label: 'Remember device',
  }), [])

  return (
    <form
      className={ styles.formFullWidth }
      onSubmit={ handleSubmit }
      autoComplete='off'
    >
      <ul>
        <li className={ styles.item }>
          <Field
            name='email'
            props={ emailFieldProps }
            component={ TextFieldWrapped }
          />
        </li>
        <li className={ styles.item }>
          <Field
            name='password'
            props={ passwordFieldProps }
            component={ TextFieldWrapped }
          />
        </li>
        <li className={ styles.item }>
          <VerificationCodeHintBox />
        </li>
        <li className={ styles.item }>
          <Field
            name='code'
            component={ TextFieldWrapped }
            props={ codeFieldProps }
          />
        </li>
        <li className={ styles.item }>
          <Field
            name='remember'
            props={ rememberFieldProps }
            component={ CheckboxWrapped }
            parse={ parseValueToBoolean }
          />
        </li>

        <li className={ styles.submitItem }>
          <Button { ...getSaveButtonFormProps(props) } submit fullWidth>
            Login
          </Button>
        </li>
      </ul>
    </form>
  )
}

export const DeviceVerificationForm = reduxForm({
  form: FORM_DEVICE_VERIFICATION,
  asyncValidate: asyncValidator(schema),
  onSubmit: onFormSubmit,
  shouldAsyncValidate,
})(DeviceVerificationFormComponent)
